module.exports = __webpack_public_path__ + "static/media/parcial-marker.73dfdee1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/parcial-marker.svg
// module id = 873
// module chunks = 0